import { keyframes, styled } from '@mui/material';
import { PIE_ANIMATION_CONFIG, PIE_TRANSITION_DURATION, PIE_TRANSITION_EASING } from './pie.constants';
import { polylineLabelClassNames } from './PolylineLabel';
import { tagLabelClassNames } from './TagLabel';

const PIE_LABEL_FADE_IN = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

export const SliceGroup = styled('g')(({ theme }) => ({
  [`& .${polylineLabelClassNames.line}, & .${polylineLabelClassNames.label}`]: {
    pointerEvents: 'none',
  },
  [`& .${polylineLabelClassNames.line}`]: {
    transition: theme.transitions.create(['opacity', 'd'], PIE_ANIMATION_CONFIG),
    animation: `${PIE_LABEL_FADE_IN} ${PIE_TRANSITION_DURATION} ${PIE_TRANSITION_EASING}`,
  },
  [`& .${polylineLabelClassNames.label}`]: {
    userSelect: 'none',
    transition: theme.transitions.create(['opacity', 'x', 'y'], PIE_ANIMATION_CONFIG),
    animation: `${PIE_LABEL_FADE_IN} ${PIE_TRANSITION_DURATION} ${PIE_TRANSITION_EASING}`,
  },

  [`& .${tagLabelClassNames.root}`]: {
    pointerEvents: 'none',
    transition: theme.transitions.create(['opacity', 'x', 'y'], PIE_ANIMATION_CONFIG),
    animation: `${PIE_LABEL_FADE_IN} ${PIE_TRANSITION_DURATION} ${PIE_TRANSITION_EASING}`,
  },
  [`& .${tagLabelClassNames.content}`]: {
    transition: theme.transitions.create('transform', PIE_ANIMATION_CONFIG),
  },

  [`g[data-has-selection] &:not([data-selected]) .${polylineLabelClassNames.line},
    g[data-has-selection] &:not([data-selected]) .${polylineLabelClassNames.label},
    g[data-has-selection] &:not([data-selected]) .${tagLabelClassNames.root}`]: {
    opacity: 0.25,
  },
}));
